"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageListingNotFound = void 0;
var react_1 = __importStar(require("react"));
var AppContext_1 = __importDefault(require("../../AppProvider/AppContext"));
exports.PageListingNotFound = function (_a) {
    var image = _a.image;
    var imageNotFound = react_1.useContext(AppContext_1.default).imageNotFound;
    return (react_1.default.createElement("div", { className: "not-found text-center" },
        react_1.default.createElement("div", { className: "icon pb-3" },
            react_1.default.createElement("img", { src: image !== null && image !== void 0 ? image : imageNotFound, width: "150px" })),
        react_1.default.createElement("h3", null, "N\u00E3o encontramos nenhum resultado com esse filtro")));
};
//# sourceMappingURL=PageListingNotFound.js.map